// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/VerifyEmail.tsx
// Version: v1.0.0
// Seite für Resend-Verification (GET /verify-email?token=... macht Backend-Redirect)

import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const verified = searchParams.get("verified");
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Nach erfolgreichem Redirect von /api/v1/auth/verify-email?token=...
  if (verified === "1") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white px-4">
        <div className="max-w-md w-full text-center">
          <div className="text-5xl mb-6">✅</div>
          <h2 className="text-2xl font-bold text-gray-900 mb-3">E-Mail bestätigt!</h2>
          <p className="text-gray-500">
            Dein Account ist jetzt aktiv. Du kannst dich jetzt einloggen.
          </p>
        </div>
      </div>
    );
  }

  const handleResend = async () => {
    if (!email) return;
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/api/v1/auth/resend-verification", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (res.status === 429) {
        const data = await res.json();
        setError(data.detail || "Bitte warte kurz.");
        return;
      }
      setSent(true);
    } catch {
      setError("Netzwerkfehler.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="text-5xl mb-4">✉️</div>
          <h2 className="text-2xl font-bold text-gray-900">Bestätigungs-E-Mail erneut senden</h2>
        </div>

        {sent ? (
          <p className="text-center text-gray-500">
            Falls die Adresse registriert ist, haben wir eine neue Mail gesendet.
          </p>
        ) : (
          <div className="space-y-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="deine@email.de"
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            {error && <p className="text-red-500 text-sm">{error}</p>}
            <button
              onClick={handleResend}
              disabled={!email || loading}
              className="w-full py-3 rounded-xl bg-indigo-600 text-white font-semibold text-sm hover:bg-indigo-700 disabled:bg-gray-200 disabled:text-gray-400"
            >
              {loading ? "Sende…" : "Bestätigungsmail senden"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
